import { render, staticRenderFns } from "./DetailPrescribedDrugsDiagnosisRep.vue?vue&type=template&id=c618fad2&"
import script from "./DetailPrescribedDrugsDiagnosisRep.vue?vue&type=script&lang=js&"
export * from "./DetailPrescribedDrugsDiagnosisRep.vue?vue&type=script&lang=js&"
import style0 from "./DetailPrescribedDrugsDiagnosisRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports